document.addEventListener("DOMContentLoaded", function() {
  var customImageSlider = new Swiper(".customImageSwiper", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    freeMode: true,
    freeModeMomentum: false
  });

  var customSlides = document.querySelectorAll(".customImageSwiper .swiper-slide");
  var customWrapper = document.querySelector(".customImageSwiper .swiper-wrapper");

  if (customSlides.length < 6 && customWrapper) {
    customSlides.forEach(function(slide) {
      customWrapper.appendChild(slide.cloneNode(true));
      customWrapper.appendChild(slide.cloneNode(true));
    });
  }

  setTimeout(function() {
    const scrollButtons = document.querySelectorAll('.scroll-button');
    
    scrollButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-scroll-target');
        
        let targetElement = null;
        
        targetElement = document.getElementById(targetId);
        
        if (!targetElement) {
          targetElement = document.querySelector('#' + targetId);
        }
        
        if (!targetElement) {
          targetElement = document.querySelector('product-info');
        }
        
        if (!targetElement) {
          targetElement = document.querySelector('[id*="ProductInfo"]');
        }
        
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }, 500);
});